/**
 * Which optional sign-in providers the app shows. One switch per provider, read
 * by Sign in, Sign up and the invitation acceptance page.
 *
 * Apple is off (user, 2026-10-24, board "Later" / PB-U7): there is no Apple
 * Developer membership yet and Apple isn't configured on UAT or prod, so the
 * button only produced an error. Turning it back on: finish the Apple setup on
 * both projects first (steps on the board), then set this to true.
 */
export const APPLE_SIGN_IN_ENABLED = false
